export const MediaList = [{
		mediaName: 'Kinetic Keys: A Lightweight Zero-Knowledge Framework for Secure Digital Transactions',
		mediaPublisher: 'Projekt Kinetic',
		mediaDate: '2025',
		mediaType: 'Article',
		link: 'https://emmanuels-organization-21.gitbook.io/kinetic/kinetic-keys-a-lightweight-zero-knowledge-framework-for-secure-digital-transactions'
	},

	{
		mediaName: 'Perfectionism Is a Trap: Stop Revving, Start Driving',
		mediaPublisher: 'Medium',
		mediaDate: '2025',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/perfectionism-is-a-trap-stop-revving-start-driving-78653f9189e9'
	},

	{
		mediaName: 'Evolve or Die: Why Standing Still Is the Fastest Way to Fall Behind.',
		mediaPublisher: 'Medium',
		mediaDate: '2025',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/evolve-or-die-why-standing-still-is-the-fastest-way-to-fall-behind-fea9bcf7dcb8'
	},

	{
		mediaName: 'Improvise, Adapt, and Leverage.',
		mediaPublisher: 'Medium',
		mediaDate: '2025',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/improvise-adapt-and-leverage-22bb10d14387'
	},

	{
		mediaName: 'Deploying Smart Contracts to the Polygon and Ethereum Blockchain Using Hardhat and Ethers.js',
		mediaPublisher: 'Better Programming',
		mediaDate: '2022',
		mediaType: 'Article',
		link: 'https://betterprogramming.pub/deploying-smart-contracts-to-the-polygon-and-ethereum-blockchain-using-hardhat-and-ethers-js-2c31aa41aed0'
	},
	{
		mediaName: 'Taking the First Step with Everyday Innovator Emmanuel Bello',
		mediaPublisher: 'With Tamara Ghandour',
		mediaDate: '2022',
		mediaType: 'Podcast',
		link: 'https://www.gotolaunchstreet.com/podcast/taking-the-first-step-with-everyday-innovator-emmanuel-bello/'
	},
	{
		mediaName: 'Working collaboratively with Git and GitHub',
		mediaPublisher: 'Medium',
		mediaDate: '2019',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/working-collaboratively-with-git-and-github-f5f4acdc1684?source=user_profile---------2----------------------------'
	},
	{
		mediaName: 'Becoming World Class',
		mediaPublisher: 'Medium',
		mediaDate: '2019',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/becoming-world-class-7fa99b3d242f?source=user_profile---------4----------------------------'
	},
	{
		mediaName: "Andela's Bootcamp, what I've learnt so far",
		mediaPublisher: 'Medium',
		mediaDate: '2019',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/andelas-bootcamp-what-i-ve-learnt-so-far-904a86d0a1b6?source=user_profile---------1----------------------------'

	},

	{
		mediaName: "My Reflections on Andela's EPIC values",
		mediaPublisher: 'Medium',
		mediaDate: '2019',
		mediaType: 'Article',
		link: 'https://medium.com/@emmanuelayodele/my-reflections-on-andelas-epic-values-6047ccb0e867?source=user_profile---------3----------------------------'
	},
]